// src/components/ErrorBoundary.js
// Top-level crash guard — shows a friendly fallback instead of a blank page
// if something throws during render (e.g. corrupted localStorage data).

import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('Unhandled render error:', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    padding: '24px',
                    backgroundColor: '#0a0a0a',
                    color: '#fff',
                }}>
                    <h1 style={{ fontSize: '1.5rem', fontWeight: 400, marginBottom: '12px' }}>
                        Something went wrong.
                    </h1>
                    <p style={{ color: 'rgba(255,255,255,0.6)', marginBottom: '24px' }}>
                        We hit an unexpected error. Please reload the page.
                    </p>
                    <button
                        onClick={() => { window.location.href = '/'; }}
                        style={{
                            backgroundColor: '#CEAC8F',
                            color: '#1a1a1a',
                            padding: '12px 32px',
                            borderRadius: '8px',
                            border: 'none',
                            fontSize: '14px',
                            cursor: 'pointer',
                        }}
                    >
                        Reload
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
